import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout/layout.vue'
import Login from './views/login/login.vue'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: 'home',
      beforeEnter: (to, from, next) => {
        // 全局路由防卫
        if (sessionStorage.getItem('Apk-Jwt-Token') || to.path == '/login') {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: 'available-domain',
          name: 'app可用域名',
          component: resolve =>
            require(['./views/pages/domain/index.vue'], resolve)
        },
        {
          path: 'app-version',
          name: 'app版本列表',
          component: resolve =>
            require(['./views/pages/app-version/index.vue'], resolve)
        }
      ]
    }
  ]
})
